// src/utils/planAccess.js
//
// Single source of truth (frontend side) for which plan codes are
// "Starter tier" and therefore excluded from premium org-admin features
// like User Management. Mirrors payments/constants.py STARTER_PLAN_CODES —
// if you add a new starter-equivalent plan code on the backend, add it here
// too.

export const STARTER_PLAN_CODES = ["starter", "starter_test"];

export const isStarterPlan = (planCode) =>
  STARTER_PLAN_CODES.includes(String(planCode || "").toLowerCase());
